import Link from 'next/link';
import { useEffect, useState } from 'react';
import { Form, message } from 'antd';
import MetaSeo from '../MetaSeo';
import useTrans from '../../hooks/useTrans';
import { useRouter } from 'next/router';

export default function Solution(props) {
  const [rows, setRows] = useState(props.rows || []);
  const trans = useTrans();
  const router = useRouter();
  useEffect(() => {
    setRows(props.rows);
  }, [props]);

  useEffect(() => {
    const asPath = router.asPath;
    const fragId = asPath.replace('/solution', '');
    console.log('=============', fragId);
    if (fragId) {
      setTimeout(() => {
        const elem = document.getElementById(fragId.replace('#', ''));
        console.log('======222222=======', elem);
        window.scrollTo({
          top: elem?.getBoundingClientRect().top,
          behavior: 'smooth',
        });
      }, 1000);
    }
  }, []);

  const dataSeo = {
    title: `${trans.layout.solution} | EYEFIRE`,
    description: trans.seo.solution.description,
  };

  return (
    <>
      <MetaSeo {...dataSeo} />
      <section className="p-solution">
        <div className="c-big-banner">
          <div className="c-big-banner__image">
            <img
              className="w-100 item-pc"
              src="./assets/img/solution/solution.webp"
              alt=""
            />
            <img
              className="item-sp w-100"
              src="./assets/img/solution/img_big-banner-sp.webp"
              alt=""
            />
          </div>
          <div className="c-big-banner__inner">
            <div className="l-container">
              <div className="c-big-banner__content solution-banner-content">
                <h3 data-aos="fade-up">{trans.solution.title_solution}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: `${trans.solution.content_solution}`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-solution__main">
          <div className="l-container">
            {rows &&
              rows.map((item, index) => {
                // if (index % 2 === 0) {
                return (
                  <div className="p-solution__box" key={index}>
                    <div className="l-row p-solution__box__row">
                      <div className="l-col">
                        <div
                          className="p-solution__box__content"
                          data-aos={`${
                            index % 2 === 0 ? 'fade-right' : 'fade-left'
                          }`}
                        >
                          <div className="p-solution__box__content-icon">
                            <img
                              src={item.background_image}
                              alt={item.seo_description}
                              title={item.seo_title}
                            />
                          </div>
                          <div className="p-solution__box__content-title">
                            <h3>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.title,
                                }}
                              ></div>
                              {/* {item.title} */}
                            </h3>
                          </div>
                          {item?.id === 10 && (
                            <img
                              src="/assets/img/solution/img_solution.png"
                              className="img-prize"
                            />
                          )}
                          <div
                            className="p-solution__box__content-desc"
                            id={item.group_id}
                          >
                            <p>
                              {/* {item.description} */}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              />
                            </p>
                          </div>
                          {(index === 0 || index === 3 || index === 4) && (
                            <div className="p-home__solution-btn btn-solution">
                              <a
                                href={`http://${
                                  index === 0
                                    ? 'sc'
                                    : index === 3
                                    ? 'aiot'
                                    : 'safety'
                                }.eyefire.vn/`}
                                target="_blank"
                                className="c-btn"
                                tabIndex="0"
                              >
                                {trans.text_button.more}
                              </a>
                              <img
                                src="/assets/img/home/icn_right.svg"
                                alt=""
                                loading="lazy"
                              />
                            </div>
                          )}
                          {/* <div className='p-solution__box__content-handle'>
                                                        <a href='#'>
                                                            {trans.text_button.read_more}
                                                            <img src='./assets/img/solution/icn_more.svg' alt='' />
                                                        </a>
                                                    </div> */}
                        </div>
                      </div>
                      <div className="l-col-auto">
                        <div
                          className="p-solution__box__image"
                          data-aos={`${
                            index % 2 === 0 ? 'fade-left' : 'fade-right'
                          }`}
                        >
                          <img
                            className="w-100 item-pc"
                            src={item?.image}
                            alt={item.seo_description}
                            title={item.seo_title}
                          />
                          <img
                            className="w-100 item-sp"
                            src={item?.background_image_mobile}
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
                // }
                // return (
                //     <div className='p-solution__box'>
                //         <div className='l-row p-solution__box__row'>
                //             <div className='l-col'>
                //                 <div className='p-solution__box__content ' data-aos='fade-left'>
                //                     <div className='p-solution__box__content-icon'>
                //                         <img src={item.background_image} alt='' />
                //                     </div>
                //                     <div className='p-solution__box__content-title'>
                //                         <h3>
                //                             {item.title}
                //                         </h3>
                //                     </div>
                //                     <div className='p-solution__box__content-desc'>
                //                         <p>
                //                             {/* {item.description} */}
                //                             <div dangerouslySetInnerHTML={{ __html: item.description }} />
                //                         </p>
                //                     </div>
                //                     {/* <div className='p-solution__box__content-handle'>
                //                         <a href='#'>
                //                             Tìm hiểu thêm
                //                             <img src='./assets/img/solution/icn_more.svg' alt='' />
                //                         </a>
                //                     </div> */}
                //                 </div>
                //             </div>
                //             <div className='l-col-auto'>
                //                 <div className='p-solution__box__image' data-aos='fade-right'>
                //                     <img className='w-100' src={item.image} alt='' />
                //                 </div>
                //             </div>
                //         </div>
                //     </div>
                // );
              })}
          </div>
        </div>
      </section>
    </>
  );
}
